import { formatNumberWithFractionDigits } from 'helpers/thousandFormatNumber';
import { convertEnergyNewTrendsData, convertEnergyTrendsData } from 'helpers/convertEnergy';
import { EChartsOption } from 'echarts';
import { defaultYAxisConfig } from 'pages/NewOverview/constants';
import { colors } from 'styles/colors';
import { YAXisOption } from 'echarts/types/dist/shared';
import { EnergyTrendsData } from './types';
import { GetEnergyTrendsHistory } from '~/pages/NewOverview/types';

export function formatterTooltipValues(value?: string | number | null): string {
  if (!value || Number(value) === 0) {
    return '-';
  }

  const numberValue = Number(value);

  const [formattedValue, unit] = formatterNumbers(numberValue);

  return `${formattedValue}${unit}h`;
}

export function formatterNumbers(value?: number | null): [string, string] {
  if (!value) {
    return ['-', 'kW'];
  }

  const [valueDemandConverted, valueDemandUnitMeasurement] = convertEnergyTrendsData(value);

  return [
    formatNumberWithFractionDigits(valueDemandConverted, { minimum: 1, maximum: 1 }),
    valueDemandUnitMeasurement,
  ];
}
export function formatterNewTrendsNumbers(value?: number | null): [string, string] {
  if (!value) {
    return ['-', 'kW'];
  }

  const [valueDemandConverted, valueDemandUnitMeasurement] = convertEnergyNewTrendsData(value);

  return [
    formatNumberWithFractionDigits(valueDemandConverted, { minimum: 0, maximum: 0 }),
    valueDemandUnitMeasurement,
  ];
}

export function yAxisFormatter(value: number): string {
  if (value === 0) {
    return '0';
  }

  const [formattedValue, unit] = formatterNewTrendsNumbers(value);

  return `${formattedValue} ${unit}h`;
}

export function createYAxis(): EChartsOption['yAxis'] {
  return {
    ...defaultYAxisConfig,
    axisLabel: {
      ...defaultYAxisConfig.axisLabel,
      fontSize: 9,
      color: colors.text['main-900'],
      formatter: yAxisFormatter,
    },
    offset: 12,
    axisTick: { show: false },
  } as YAXisOption;
}

export function parseTrendsData(data: GetEnergyTrendsHistory): EnergyTrendsData {
  return {
    trendsData: parseHistory(data.HISTORY),
    monthlyForecast: data.MONTHLY_FORECAST,
    monthlyForecastPercentage: data.MONTHLY_FORECAST_PERCENTAGE,
    monthlyTarget: data.MONTHLY_TARGET,
    totalConsumption: data.TOTAL_CONSUMPTION,
    totalConsumptionPercentage: data.TOTAL_CONSUMPTION_PERCENTAGE,
  };
}

function parseHistory(history: GetEnergyTrendsHistory['HISTORY']): EnergyTrendsData['trendsData'] {
  let lastConsumption = 0;

  const trendsData: EnergyTrendsData['trendsData'] = [];

  for (const item of history) {
    if (lastConsumption === 0 || item.CONSUMPTION !== 0) {
      lastConsumption = item.CONSUMPTION;
    }

    trendsData.push({
      consumption: item.CONSUMPTION,
      consumptionForecast: item.CONSUMPTION_FORECAST,
      consumptionOverTarget: item.CONSUMPTION_OVER_TARGET,
      consumptionPercentage: item.CONSUMPTION_PERCENTAGE,
      consumptionTarget: item.CONSUMPTION_TARGET,
      time: item.TIME,
      lastConsumption,
    });
  }

  return trendsData;
}
